import axios from "axios";

const BACKEND_URL = 'https://backend/cpsconsultingservices.com';
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitProject = (payload) => api.post("/projects", payload).then((r) => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
